import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/services/StoreService/SessionService/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const user = this.sessionService.getUser() || null;

    if(!user){
      this.router.navigate(["/pb/log-in"]);
      return false;
    }

    return true;

    /*
    if (!localStorage.getItem("email")) {
      this.router.navigate(["/pb/log-in"]);
      return false;
    }
    return true;
    */
  }
}
